import { render, staticRenderFns } from "./ProductDownloads.vue?vue&type=template&id=3ee4e04c&scoped=true&"
import script from "./ProductDownloads.vue?vue&type=script&lang=js&"
export * from "./ProductDownloads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee4e04c",
  null
  
)

export default component.exports